import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, Map, Clock, Calendar } from 'lucide-react';
export function WhatIncludes() {
  const items = [{
    title: 'Árbol de Decisión 2AM',
    desc: '1 página imprimible para tener en la mesa de noche.',
    icon: <Map className="w-5 h-5 text-[#5b8a7a]" data-id="element-363" />
  }, {
    title: 'Guion Base de 90 Segundos',
    desc: 'Para empezar cada despertar con calma.',
    icon: <Clock className="w-5 h-5 text-[#5b8a7a]" data-id="element-364" />
  }, {
    title: 'Scripts por Ruta (A–E)',
    desc: 'Instrucciones paso a paso para Hambre, Pañal, Gases, Contacto y Transferencia.',
    icon: <FileText className="w-5 h-5 text-[#5b8a7a]" data-id="element-365" />,
    subItems: ['Ruta A: Hambre / Toma', 'Ruta B: Pañal / Temperatura', 'Ruta C: Gases / Eructo', 'Ruta D: Contacto / Regulación', 'Ruta E: Transferencia']
  }, {
    title: 'Regla 8–12 Minutos',
    desc: 'Para salir del ciclo de "probarlo todo" sin resultado.',
    icon: <Clock className="w-5 h-5 text-[#5b8a7a]" data-id="element-366" />
  }, {
    title: 'Tracker de 14 Noches',
    desc: 'Para ver patrones reales y dejar de adivinar.',
    icon: <Calendar className="w-5 h-5 text-[#5b8a7a]" data-id="element-367" />
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-368">
      <div className="max-w-3xl mx-auto" data-id="element-369">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-12 text-center" data-id="element-370">
          Qué Incluye (Claro y Simple)
        </motion.h2>

        <div className="space-y-6" data-id="element-371">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-4 md:gap-6 p-6 rounded-xl bg-[#faf7f2] border border-[#f1f5f9]" data-id="element-372">
              <div className="shrink-0 mt-1" data-id="element-373">
                <div className="w-8 h-8 rounded-full bg-[#e0f2fe] flex items-center justify-center" data-id="element-374">
                  <span className="text-[#0369a1] font-bold text-sm" data-id="element-375">
                    {i + 1}
                  </span>
                </div>
              </div>
              <div className="flex-1" data-id="element-376">
                <h3 className="font-serif text-xl text-[#0f172a] font-medium mb-2 flex items-center gap-2" data-id="element-377">
                  {item.title}
                </h3>
                <p className="text-[#64748b] mb-3" data-id="element-378">{item.desc}</p>

                {item.subItems && <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-379">
                    {item.subItems.map((sub, j) => <div key={j} className="flex items-center gap-2 text-sm text-[#475569] bg-white px-3 py-2 rounded border border-[#e2e8f0]" data-id="element-380">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#5b8a7a]" data-id="element-381" />
                        {sub}
                      </div>)}
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}